import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import './SingleService.css';

function SingleService({ service, onClick }) {
    const { title, desc, color, bg, icon } = service;

    return (
        <div
            className="svc-card"
            onClick={onClick}
            style={{ '--svc-color': color, '--svc-bg': bg }}
        >
            {/* بخش بصری بالا */}
            <div className="svc-card__visual">
                <span className="svc-card__badge" />
                <img src={icon} alt={title} className="svc-card__img" />
            </div>

            {/* محتوا */}
            <div className="svc-card__body">
                <h3 className="svc-card__title">{title}</h3>
                <p className="svc-card__desc">{desc}</p>
                <span className="svc-card__link" style={{ color }}>
                    مشاهده <FaArrowLeft size={11} />
                </span>
            </div>
        </div>
    );
}

export default SingleService;
